import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './styles/index.css';
import './i18n/bootstrap'; // SEO: URL 언어 prefix 감지 → localStorage 동기화 (i18n 초기화 전에 실행)
import './i18n'; // i18next 초기화 (앱 시작 전 로드)
import { getBasename } from './i18n/bootstrap';
import App from './App';
import { AuthProvider, LanguageProvider, FxRateProvider } from './contexts';

const rootEl = document.getElementById('root');

// SEO: inject_seo 가 #root 형제로 심은 비-JS 크롤러용 본문 블록을 React 마운트 전에 제거.
// → 실사용 DOM 중복(특히 h1) 방지. #root 밖이라 아래 hasChildNodes() 분기엔 영향 없음.
document.getElementById('seo-prerender')?.remove();

// react-snap이 prerender한 HTML이 있으면 hydrate, 없으면 일반 렌더
const renderApp = (
  <React.StrictMode>
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <FxRateProvider>
            <App basename={getBasename()} />
          </FxRateProvider>
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  </React.StrictMode>
);

if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, renderApp);
} else {
  ReactDOM.createRoot(rootEl).render(renderApp);
}
